// src/apiConfig.js
// export const API_BASE_URL = "https://localhost:7120/api/";

export const API_BASE_URL = "https://api.couponfirstorder.com/api/";
// export const API_BASE_URL =
//   "https://carrental12344-hxehg8ggc8fmd2c9.canadacentral-01.azurewebsites.net/api/";
